import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const StudentCourses = lazyRouteComponent(() => import('@/_instructor/customer-profile/courses'));

export const Route = createFileRoute('/_instructor/student/courses')({
  component: () => renderInstructorPage(StudentCourses),
});
